var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3886 36.585H33.4678C34.0767 36.585 34.5817 36.075 34.5817 35.46C34.5817 34.845 34.0767 34.35 33.4678 34.35H25.3886C24.7797 34.35 24.2748 34.845 24.2748 35.46C24.2748 36.075 24.7797 36.585 25.3886 36.585ZM30.4084 26.85H25.3886C24.7797 26.85 24.2748 27.36 24.2748 27.975C24.2748 28.59 24.7797 29.085 25.3886 29.085H30.4084C31.0173 29.085 31.5223 28.59 31.5223 27.975C31.5223 27.36 31.0173 26.85 30.4084 26.85ZM41.0071 25.5384C41.3562 25.5344 41.7363 25.53 42.0817 25.53C42.453 25.53 42.75 25.83 42.75 26.205V38.265C42.75 41.985 39.7649 45 36.0817 45H24.2599C20.3985 45 17.25 41.835 17.25 37.935V21.765C17.25 18.045 20.25 15 23.948 15H31.8787C32.2649 15 32.5619 15.315 32.5619 15.69V20.52C32.5619 23.265 34.8045 25.515 37.5223 25.53C38.1571 25.53 38.7168 25.5347 39.2065 25.5389C39.5876 25.5421 39.9263 25.545 40.2252 25.545C40.4367 25.545 40.7107 25.5418 41.0071 25.5384ZM41.4166 23.349C40.1958 23.3535 38.7567 23.349 37.7216 23.3385C36.079 23.3385 34.726 21.972 34.726 20.313V16.359C34.726 15.7125 35.5028 15.3915 35.9468 15.858C36.7507 16.7022 37.8555 17.8627 38.9551 19.0179C40.0516 20.1697 41.143 21.3162 41.926 22.1385C42.3597 22.593 42.0419 23.3475 41.4166 23.349Z",
    fill: "#004F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProposal);
export default __webpack_public_path__ + "static/media/new-proposal.46565f73bcc00c3fa25968cb0eb27320.svg";
export { ForwardRef as ReactComponent };